import script from "./ListPosition.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListPosition.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__